import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Letter Head
function creatLetterHead(params: any) {
    const baseUrl = `/letterHead/createLetterHead`;
    return api.createWithFile(`${baseUrl}`, params);
}
// update Letter Head
function updateLetterHead(params: any) {
    const baseUrl = '/letterHead/updateLetterHead';
    return api.updatePutWithFile(`${baseUrl}`, params);
}

// get all Letter Head
function getAllLetterHead(params: any) {
    const baseUrl = '/letterHead/getLH_List';
    return api.create(`${baseUrl}`, params);
}

// get Letter Head
function getLetterHead(params: any) {
    const baseUrl = '/letterHead/getLHDetail';
    return api.create(`${baseUrl}`, params);
}

// get selected Letter Head
function getSelectedLetterHead(params: any) {
    const baseUrl = '/letterHead/getSelectedLH';
    return api.create(`${baseUrl}`, params);
}

export { creatLetterHead, updateLetterHead, getAllLetterHead, getLetterHead, getSelectedLetterHead };
